<template>
  <AtomsTitleCard heading="公式X" color="x">
    <NuxtLink
      to="https://twitter.com/DietPlusjp"
      target="_blank"
      rel="noopener"
      class="block p-6 transition-opacity duration-200 hover:opacity-70"
    >
      <div class="flex flex-col items-center gap-4 text-center">
        <div class="p-4 bg-[#000] rounded-full">
          <img src="~/assets/img/x_logo.svg" alt="X" class="w-12 h-12" />
        </div>
        <div class="flex flex-col gap-2">
          <span class="text-xl font-bold text-[#000]">@DietPlusjp</span>
          <span class="text-sm text-gray-600"
            >ダイエット情報をお届けしています</span
          >
        </div>
        <div
          class="mt-2 px-6 py-2 bg-[#000] text-white rounded-full text-sm font-bold"
        >
          フォローする
        </div>
      </div>
    </NuxtLink>
  </AtomsTitleCard>
</template>
